import { render, staticRenderFns } from "./mattype.vue?vue&type=template&id=8123f28e&scoped=true&"
import script from "./mattype.vue?vue&type=script&lang=js&"
export * from "./mattype.vue?vue&type=script&lang=js&"
import style0 from "./mattype.vue?vue&type=style&index=0&id=8123f28e&scoped=true&lang=less&"
import style1 from "./mattype.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8123f28e",
  null
  
)

export default component.exports